module.exports = __webpack_public_path__ + "img/16m009-03.420fa784.png";